// ----------------------------------------------------------------
// src/helpers/book.repository.js
//
// Read the JSON database and convert it into a Backbone-friendly
// format.
//
// ----------------------------------------------------------------
"use strict";

(function() {

	const OTHER_AFRICAN_LANGUAGES = ["isiNdebele", "Ateso", "Aringati", "Olunyala", "Yoruba", "Naro", "Sabinyi", "Kanuri", "Tshivenda", "Xitsonga", "ChiTonga", "Chinyanja", "Dhopadhola", "Lugwere", "siSwati", "Olukhayo", "Lugisu", "Leblango", "Xitswa", "Kakwa", "Gurene", "Afan Oromo", "Rutooro", "Lámnso'", "Ciyawo"];
	const OTHER_ASIAN_LANGUAGES = ["Chinese", "Persian", "Turkish", "Pashto", "Bengali", "Persian/Farsi"];

	const BookRepository = function() {};

	BookRepository.otherAfricanLanguages = function() {
		return OTHER_AFRICAN_LANGUAGES;
	};

	BookRepository.otherAsianLanguages = function() {
		return OTHER_ASIAN_LANGUAGES
	};

	/**
	 * Access all the books of the database
	 *
	 * @return BookModel[]
	*/
	BookRepository.getArrBooks = function() {
		// Create an empty array
		var books = [];
		// Create a new BookModel based on every entries from the database
		_.each(window.reads_data.book, function(book) {
		// Create the BookModel object
			var new_book = new BookModel({
				audiobook: book.audiobook,
				authors: book.authors,
				book_id: book.book_id,
				citation: book.citation,
				copyright: book.copyright,
				country: book.country,
				description: book.description,
				format: [],
				html: book.html,
				illustrators: book.illustrators,
				img: book.img,
				language: book.language,
				narrator: book.narrator,
				nbPages: book.nbPages,
				pdf: book.pdf,
				publisher: book.publisher,
				reading_level: book.reading_level,
				theme: book.theme,
				translator: book.translator,
				title: book.title,
				type: book.type,
				year: book.year,
			});
			// Push the BookModel object to the books array
			books.push(new_book);
		});
		// Return the BookModel array
		return books;
	};

	BookRepository.getArrThemes = function() {
		var themes = [];

		_.each(window.reads_data.theme, function(theme) {
			var newTheme = new ThemeModel({
				id: theme.id,
				name: theme.name,
				fr_name: theme.fr_name
			});
			themes.push(newTheme);
		});

		return themes;
	};

	BookRepository.getArrPublishers = function() {
		return window.reads_data.publisher.map(function(el) {
			return el.name.replace(/^ /g, "");
		}).sort(function(a, b) {
			return a.toLowerCase().localeCompare(b.toLowerCase());
		});
	};

	/**
	 * Return a BookCollection containing all the books from the database
	 *
	 * @return BookCollection
	 */
	BookRepository.getCollectionBooks = function() {
		var books = BookRepository.getArrBooks();
		return new BookCollection(books);
	};

	/**
	 * Return a BookCollection containing all the Other African Languages
	 *
	 * @return BookCollection
	 */
	BookRepository.getOtherAfricanLanguages = function() {
		return BookRepository.otherAfricanLanguages;
	};

	/**
	 * Return a BookCollection containing all the Other Asian Languages
	 *
	 * @return BookCollection
	 */
	BookRepository.getOtherAsianLanguages = function() {
		return BookRepository.otherAsianLanguages;
	};

	window.BookRepository = BookRepository;

})();





